import React, { useState } from 'react';
import classNames from 'classnames';
import styled from 'styled-components/macro';

function ModalTitle(props: { state?: string }) {
  switch (props.state) {
    case 'complete':
      return <b>WEB投票が完了しました</b>;
    case 'failed':
      return <b>WEB投票に失敗しました</b>;
    default:
      return null;
  }
}

const Root = styled.div`
  .modal-card {
    padding: 10px;
    border: 10px solid white;
    background-color: white;
  }
  .modal-card-head,
  .modal-card-foot {
    border-radius: 0;
    border: none;
    background: transparent;
  }
`;

export function VoteResultModal(props: { query: { state?: string; message?: string } }) {
  let [active, setActive] = useState(true);
  if (!props.query.state) {
    return null;
  }

  return (
    <Root
      className={classNames('modal is-padding-1', {
        'is-active': active,
      })}
    >
      <div
        className="modal-background"
        onClick={() => {
          setActive(false);
        }}
      />
      <div className="modal-card has-background-black-stripe">
        <header className="modal-card-head is-padding-top-0-5 is-padding-left-1 is-padding-right-0-5">
          <p className="modal-card-title modal-card-title is-size-5">
            <ModalTitle state={props.query.state} />
          </p>
          <button
            className="delete"
            aria-label="close"
            onClick={() => {
              window.history.replaceState('', '', location.pathname);
              setActive(false);
            }}
          />
        </header>
        <section className="modal-card-body is-padding-0">
          <div className="content">
            <p
              className={classNames('notification has-text-weight-bold', {
                'is-warning': props.query.state == 'complete',
                'is-danger': props.query.state == 'failed',
              })}
            >
              {props.query.message}
            </p>
          </div>
        </section>
        <footer className="modal-card-foot" />
      </div>
    </Root>
  );
}
